<template>
  <div>
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex xs12>
        <div class="px-4 pb-3 my-4">
          <v-btn style="position: absolute; top: 0px; right: 5px" @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>

          <div style="font-size: 20px; font-weight: 600" class="my-3 primary--text">
            Shop : {{ shop }}
          </div>
          <div>
            <v-layout row wrap>
              <template v-for="(product, category) in dataPurchaseDetail">
                <v-flex xs3 :key="category" class="px-2">
                  <v-card
                    class="pa-4 text-center"
                    style="cursor: pointer"
                    @click="showProduct(category)"
                    :style="
                      selectedCategory === category
                        ? 'background-color: #CCC'
                        : 'background-color: #E8E8E8;'
                    "
                  >
                    <div class="pb-2" style="font-weight: 600; font-size: 16px">{{ category }}</div>
                    <div>{{ product.total }}</div>
                  </v-card>
                </v-flex>
              </template>
            </v-layout>
          </div>

          <div v-if="productsData" class="mt-4">
            <div class="pa-2" style="font-weight: 600; font-size: 16px">{{ selectedCategory }}</div>
            <v-layout row wrap>
              <template v-for="(qty, name) in productsData">
                <v-flex xs3 :key="name" class="px-2">
                  <v-card class="pa-4 text-center" style="background-color: #e8e8e8">
                    <div class="pb-2" style="font-weight: 600; font-size: 16px">{{ name }}</div>
                    <div>{{ qty }}</div>
                  </v-card>
                </v-flex>
              </template>
            </v-layout>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: ['shop', 'selectedDate'],
  components: {},
  data() {
    return {
      loading: false,
      offset: 0,
      limit: 10,

      dataPurchaseDetail: [],
      productsData: '',
      selectedCategory: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageid() {
      return this.selectedBot.pageid
    }
  },
  mounted() {
    this.getPurchaseShopDetails()
  },
  methods: {
    getPurchaseShopDetails() {
      var vm = this
      var data = {
        pageid: vm.pageid,
        start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
        end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
        shop_via: this.shop
      }
      this.loading = true
      api.getLamyOverview2PurchaseByShopDetails(data, (err, response) => {
        if (response.responsecode == 200) {
          vm.dataPurchaseDetail = response.data[0]
          this.loading = false
        } else {
          console.log(err)
          return
        }
      })
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },

    showProduct(category) {
      var data = this.dataPurchaseDetail
      let products
      if (data.hasOwnProperty(category)) {
        products = data[category].products
      }

      // var test = Object.keys(products)

      // console.log(test);
      this.selectedCategory = category
      this.productsData = products
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/PurchaseByShopDetailsModal.vue